import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

//UI
import MainLayout from '@/components/Layout/MainLayout'

//State

import { authSelector } from '@/stores/auth/authSlice'
import { UserRole } from '@/features/users/constants'
import privateRoutes from '../PrivateRoutes/index.jsx'

const PrivateRouteMiddleware = () => {
  const { isAuthenticated, user } = useSelector(authSelector)

  const navigate = useNavigate()
  const location = useLocation()
  const params = new URLSearchParams(location.search)


  useEffect(() => {
    if (user && user?.role === UserRole.VENDOR && !user.hasUpdatedPassword && user?._id) {
      toast.info('Welcome to the E Approval System, please update your password')
      navigate(`/users/newPassword?id=${user?._id}`)
    }
  }, [navigate, user])

  if (!isAuthenticated) {
    // toast.error('You need to be logged in to access this page');
    return <Navigate to={`/auth/login?${params.toString()}`} state={{ from: location }} />
  }

  return (
    <MainLayout routes={privateRoutes}>
      <Outlet />
    </MainLayout>
  )
}

export default PrivateRouteMiddleware
